import { Component, OnInit, NgZone, input } from '@angular/core';
import { environment } from '../../environments/environment';
import { WorkerService } from '../services/worker.service';
import { MenusComponent } from '../menus/menus.component';
import { TranslocoService } from '@jsverse/transloco';
import * as XLSX from 'xlsx';
import { DialogService } from '../services/dialog.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';

const API_URL = environment.API_URL;

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrl: './import.component.css'
})
export class ImportComponent implements OnInit {

  constructor(private ngZone: NgZone, private menusComponent: MenusComponent,
    private dialogService: DialogService, private workerService: WorkerService,
    private translocoService: TranslocoService, private router: Router, 
    public storageService: StorageService) { }

  filename = "";
  errorMsg = "";
  plantillaLink = "";

  selectedFile: any = null;
  ngOnInit(): void {
    this.plantillaLink = `${API_URL}/companies/${this.storageService.companyId}/workers/import/layout`;
  }


  fileBrowseHandler(event: any) {
    const file = event.target.files[0];
    this.filename = file.name;

    if (this.filename.slice(-5).toLowerCase() !== '.xlsx') {
      this.translocoService.selectTranslate('import.errorFormat')
        .subscribe((translatedTitle: string) => {
          this.errorMsg = translatedTitle;
        });
      this.filename = '';
      this.selectedFile = null;
      return;
    }

    this.selectedFile = file;
    this.errorMsg = '';
  }

  uploadFile(): void {
    if (this.selectedFile) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const arrayBuffer = e.target.result;
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const formattedData = this.formatData(json);

        console.log('Datos a enviar:', formattedData);
        this.workerService.postFile(formattedData, this.storageService.companyId)
          .subscribe({
            next: (res) => {
              console.log(res.message);
              this.msgDialog(res.message, '', true, 'O');
            },
            error: (e) => {
              console.error(e.error.message);
              this.msgDialog('ERROR', e.error.message, false, 'E');
            },
          });
      };
      reader.readAsArrayBuffer(this.selectedFile);
    } else {
      this.translocoService.selectTranslate('import.errorSelect')
      .subscribe((translatedTitle: string) => {
        this.errorMsg = translatedTitle;
      });
    }
  }

  formatData(json: any[]): { first_name: string; last_name: string; dni: string }[] {
    return json.slice(1).map(row => {
      const [first_name, last_name, dni] = row as [string, string, string];
      // Return the formatted object
      return {
        first_name: first_name ?? '',
        last_name: last_name ?? '',
        dni: dni ?? ''
      };
    });
  }

  msgDialog(msgShow: string, msg2Show: string, isOK: boolean, type: string) {
    this.dialogService.confirmDialog({
      title: 'Trabajador',
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    })
      .subscribe((yes) => {
        if (isOK) {
          setTimeout(() => {
            this.router.navigate(['workers']);
          }, 1000);
        }
      });
  }

  downloadLink(){
    console.log("Click")
    this.workerService.downloadLayout(this.plantillaLink).subscribe(
      (blob: Blob) => {
        this.workerService.saveFile(blob); // Guardar el archivo localmente
      },
      error => {
        console.error('Error durante la descarga del archivo', error);
        // Manejo de errores adicionales si es necesario
      }
    );
  }
}